export const useProtos = () => {
    Array.prototype.deleteColsFromArray = function(boolFlag,fieldsNames=[]){
        return boolFlag ? this.filter((x) => !fieldsNames.includes(x.field)) : this
    }

    Array.prototype.renameCol = function (field,newName){
        return this.map((x) => {
            if (x.field === field) x.title = newName;
            return x
        });
    }

    Array.prototype.addStartColumn = function (options){
        return [{...options},...this]
    }
}
